const renderExpertModal = () => {
  const pageBody = document.querySelector('body');
  const expertModal = document.querySelector('[data-modal="expert-modal"]');
  if (!expertModal) return;

  const modalTitle = expertModal.querySelector('.expert-card__info b');
  const modalImage = expertModal.querySelector('.expert-card__image img');
  const modalJob = expertModal.querySelector('.expert-card__info span');
  const modalInfo = expertModal.querySelector('.expert-card__resume');

  const onCardClick = (evt) => {
    if (evt.target.closest('[data-open-modal="expert-modal"]')) {
      const targetCard = evt.target.closest('.expert-card');
      const cardName = targetCard.querySelector('b').textContent;
      const cardImage = targetCard.querySelector('img');
      const cardJob = targetCard.querySelector('.expert-card__info span').textContent;
      const cardInfo = targetCard.querySelector('.expert-card__content').outerHTML;
      
      modalTitle.textContent = cardName;
      modalImage.src = cardImage.src;
      modalImage.alt = cardImage.alt;
      modalJob.textContent = cardJob;
      modalInfo.innerHTML = cardInfo;
    }
  };

  pageBody.addEventListener('click', onCardClick);
};

export default renderExpertModal;
